

function NoDataFound(){

    return (
        <div className="w-100">
            <h5 className="text-danger text-center mt-2 ">No Data Found</h5>
        </div>
    )

}

export default NoDataFound